import { materialTheme } from "./materialTheme";

// styled-components gets the same theme object as MUI. Styles should prefer
// the CSS custom properties from tokens.ts (`var(--ink)` etc.) over this.
export const defaultTheme = materialTheme;
